import LandingPageV2 from "./LandingPageV2";

export default LandingPageV2;
